import { render, staticRenderFns } from "./BCXPoints.vue?vue&type=template&id=79089d8c&scoped=true"
import script from "./BCXPoints.vue?vue&type=script&lang=ts"
export * from "./BCXPoints.vue?vue&type=script&lang=ts"
import style0 from "./BCXPoints.vue?vue&type=style&index=0&id=79089d8c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79089d8c",
  null
  
)

export default component.exports